module.exports = __webpack_public_path__ + "static/petkovic-red-19041160c1f9a818a6e04ff8ce2dec73.png";